// noinspection JSValidateTypes

import React, {useEffect} from "react";
import {Switch, Route, Link} from 'react-router-dom';
import {Nav, Navbar, NavDropdown} from "react-bootstrap";

import './App.scss';
import NewJob from "./Views/NewJob/NewJob";
import JobsList from "./Views/JobsList/JobsList";
import PageNotFound404 from "./Views/PageNotFound404";
import JobDetails from "./Views/JobDetails/JobDetails";
import NewClient from "./Views/NewClient/NewClient";
import ClientsList from "./Views/ClientsList/ClientsList";
import ClientDetails from "./Views/ClientDetails/ClientDetails";
import LoginLogout from "./Views/UserProfile/LoginLogout";
import {useAuth0} from "@auth0/auth0-react";
import UserProfile from "./Views/UserProfile/UserProfile";
import {useState} from "@hookstate/core";
import {getUserData} from "./Services/ApiService";
import AdvancedSearch from "./Views/AdvancedSearch/AdvancedSearch";
import Calculator from "./Views/Calculator/Calculator";
import InvoiceParser from "./Views/ParseInvoices/InvoiceParser";

function Routing() {
    const {user, isAuthenticated, isLoading, getAccessTokenSilently} = useAuth0();
    const isAdmin = useState(false);
    const userChecked = useState(false);


    async function SetToken() {
        try {
            const accessToken = await getAccessTokenSilently();
            localStorage.setItem('accessToken', accessToken);
        } catch (error) {
            console.error('Failed to get access token:', error);
        }
    }

    useEffect(() => {
        if (process.env.REACT_APP_DEV === 'true' && !document.title.includes("DEV")) {
            document.title += " DEV";
        }

        if (!user || userChecked.get()) return;
        getUserData(user.sub, _user => {
            // noinspection JSUnresolvedReference
            isAdmin.set(Boolean(_user.isAdmin));
            userChecked.set(true);
        })

        SetToken().then();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    function Loading() {
        return <div id={'loading'}>
            <h3>Loading...</h3>
        </div>
    }

    function Login() {
        return <div id={'notLoggedIn'}>
            <h3>Please <LoginLogout /> to continue</h3>
        </div>
    }

    function Switches() {
        return <Switch>
            <Route exact path={"/"}>
                <JobsList />
            </Route>
            <Route exact path={"/jobs"}>
                <JobsList />
            </Route>
            <Route path={"/newJob"}>
                <NewJob />
            </Route>
            <Route path={"/client/new"}>
                <NewClient />
            </Route>
            <Route path={'/clients'}>
                <ClientsList />
            </Route>
            <Route path={"/client/:clientId"}>
                <ClientDetails />
            </Route>
            <Route path={"/job/:jobId"}>
                <JobDetails />
            </Route>
            <Route path={'/user'}>
                <UserProfile />
            </Route>
            <Route path={"/advancedSearch"}>
                <AdvancedSearch />
            </Route>
            <Route path={"/calculator"}>
                <Calculator />
            </Route>
            <Route path={'/invoices'}>
                <InvoiceParser />
            </Route>
            <Route path={"*"}>
                <PageNotFound404 />
            </Route>
        </Switch>
    }

    return (
        <div id={'content'}>
            <Navbar bg={'light'}>
                <Navbar.Brand className={`dev-${process.env.REACT_APP_DEV}`}>
                    <h1>PPI Internal {process.env.REACT_APP_DEV === 'true' && "DEV "}</h1>
                </Navbar.Brand>
                <Nav className={'mr-auto'}>
                    <Nav.Item>
                        <Nav.Link as={Link} to={"/jobs"}>Jobs</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link as={Link} to={"/newJob"} onClick={() => {
                            window.location.href = "/newJob"
                        }}>New Job</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link as={Link} to={"/clients"}>Clients</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link as={Link} to={'/calculator'}>Impose Calculator</Nav.Link>
                    </Nav.Item>
                    {isAdmin.get() &&
                        <div>
                            <NavDropdown id={'Admin Tools'} title={'Admin Tools'} renderMenuOnMount={true}>
                                <NavDropdown.Item as={Link} to={'/invoices'}>Invoices</NavDropdown.Item>
                            </NavDropdown>
                        </div>
                    }
                </Nav>
                <LoginLogout />
            </Navbar>
            <br/>
            <div id={"body"}>
                {isLoading ? (
                    Loading()
                ) : (
                    <div>
                        {userChecked.get() ? (
                            <div id={'userCheck'}>
                                {!isAuthenticated ? (
                                    Login()
                                ) : (
                                    Switches()
                                )}
                            </div>
                        ) :
                            !isAuthenticated ? (
                                Login()
                            ) : (
                                Loading()
                            )
                        }
                    </div>
                )}
            </div>
        </div>
    );
}

export default Routing;
